<template>
  <div>
    <transaction-type-form :is-new="false" />
  </div>
</template>

<script>
import TransactionTypeForm from '../components/TransactionTypeForm.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import transactionTypeStore from '../transactionTypesStore'

export default {
  components: {
    TransactionTypeForm,
  },
  setup(_, ctx) {
    useRegisterStoreModule('transactionTypes', transactionTypeStore)
    if (!ctx.root.$store.getters['transactionTypes/getTransactionTypeInfo']) {
      ctx.root.$router.push('/transaction-types')
    }
  },
}
</script>

<style>

</style>
